import $ from "jquery";

window.addEventListener("message", function (event) {
  const frames = document.getElementsByTagName("iframe");
  for (let i = 0; i < frames.length; i++) {
    if (frames[i].contentWindow === event.source) {
      $(frames[i]).height(event.data);
      break;
    }
  }
});
